var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
import { toJS } from "mobx";
import { useFormContext } from "../Form";
import { CheckedStates } from "../Checkbox";
import { observer } from "mobx-react-lite";
export var SelectAllTableCheckbox = observer(function (_a) {
    var _b;
    var data = _a.data, form = _a.form, className = _a.className, onChange = _a.onChange, _c = _a.invert, invert = _c === void 0 ? false : _c, dataTestId = _a.dataTestId, dataId = _a.dataId, totalDataLength = _a.totalDataLength;
    var name = form.name;
    var componentId = "".concat(name, "SelectAll");
    var values = useFormContext().values;
    var collection = toJS(values.get(name));
    data =
        (_b = data === null || data === void 0 ? void 0 : data.map(function (row) { return form.idIdentifier && row[form.idIdentifier]; })) !== null && _b !== void 0 ? _b : [];
    var someRowsAreInCollection = function () {
        return collection.filter(function (item) { return data && data.includes(item); });
    };
    var allRowsAreInCollection = function (data) {
        return data.every(function (row) { return collection.includes(row); });
    };
    var getCheckedState = function () {
        if (invert) {
            if (collection.length === totalDataLength) {
                return CheckedStates.Unchecked;
            }
            if (collection.length === 0) {
                return CheckedStates.Checked;
            }
            return CheckedStates.Indeterminate;
        }
        if (data && data.length && allRowsAreInCollection(data)) {
            return CheckedStates.Checked;
        }
        if (someRowsAreInCollection().length >= 1) {
            return CheckedStates.Indeterminate;
        }
        return CheckedStates.Unchecked;
    };
    var _d = useState(getCheckedState()), checked = _d[0], setChecked = _d[1];
    useEffect(function () { return setChecked(getCheckedState()); }, [collection]);
    var handleOnChange = function () {
        if (checked === CheckedStates.Checked) {
            collection = collection.filter(function (item) { return data && !data.includes(item); });
            values.set(name, collection);
        }
        else {
            var mergedArrays = data
                ? Array.from(new Set(__spreadArray(__spreadArray([], collection, true), data, true)))
                : collection;
            values.set(name, mergedArrays);
        }
        onChange && onChange(checked);
    };
    return (React.createElement("label", { className: className, "data-testid": dataTestId !== null && dataTestId !== void 0 ? dataTestId : "", "data-id": dataId !== null && dataId !== void 0 ? dataId : "" },
        React.createElement("input", { name: componentId, id: componentId, type: "checkbox", checked: checked === CheckedStates.Checked, ref: function (el) {
                return el && (el.indeterminate = checked === CheckedStates.Indeterminate);
            }, onChange: handleOnChange, "data-indeterminate": checked === CheckedStates.Indeterminate, disabled: !data || data.length === 0 }),
        React.createElement("span", { className: "sr-only" }, "Select all rows")));
});
